import react from '../../assets/reactLogo.webp'
import typescript from '../../assets/typescriptLogo.webp'
import vue from '../../assets/vueLogo.webp'
import node from '../../assets/nodeLogo.webp'
import nest from '../../assets/nestLogo.webp'
import xd from '../../assets/xdLogo.webp'
import figma from '../../assets/figmaLogo.webp'
import jira from '../../assets/jiraLogo.webp'
import framer from '../../assets/framerLogo.webp'
import wordpress from '../../assets/wordpressLogo.webp'
import postgre from '../../assets/postgreLogo.webp'
import mongo from '../../assets/mongoLogo.webp'

export const stackItems = [
    { name: 'React', description: 'Front-End Development', icon: react },
    { name: 'VueJS', description: 'Front-End Development', icon: vue },
    { name: 'TypeScript', description: 'Typed Language', icon: typescript },
    { name: 'NodeJS', description: 'Backend Development', icon: node },
    { name: 'NestJS', description: 'Backend Framework', icon: nest },
    { name: 'AdobeXD', description: 'UI/UX Design', icon: xd },
    { name: 'Figma', description: 'UI/UX Design', icon: figma },
    { name: 'Jira', description: 'Project Management', icon: jira },
    { name: 'Framer', description: 'Prototyping Tool', icon: framer },
    { name: 'WordPress', description: 'CMS Platform', icon: wordpress },
    { name: 'PostgreSQL', description: 'Database Management', icon: postgre },
    { name: 'MongoDB', description: 'NoSQL Database', icon: mongo },
  ];